// import { oc }                           from "ts-optchain";
// import { ErrorLogService }              from "@/services/";
import { formatDateTime, stringHelper } from "@/components/mixins";
import Vue from "vue";
import { mapGetters } from "vuex";
import { constants }    from "@/const";
import { FeatureFlagService } from "@/services/FeatureFlagService";


export default Vue.extend({
    name: "CartFooter",
    components: {},
    mixins: [formatDateTime, stringHelper],

    created() {
        return
    },
    computed: {
        ...mapGetters([
            "user",
            "getContentItem",
            "IsMcfa",
            "IsMcfe"
        ]),
        privacyLink() {
            return this.getContentItem(window.appGlobals.GLOBAL_LOGIN_PRIVACY_POLICY_KEY);
        },
        cookieLink() {
            return this.getContentItem(window.appGlobals.GLOBAL_LOGIN_COOKIE_POLICY_KEY);
        },
        termsAndConditionsLink() {
            return this.getContentItem(window.appGlobals.GLOBAL_LOGIN_TERMS_AND_CONDITIONS_KEY);
        },
        showPrivacyFooter(){
            return FeatureFlagService.getFeatureEnabled(constants.FEATURE_NAMES.SHOW_PRIVACY_FOOTER);
        }
    },
    data: () => ({
    }),
    methods: {
    },
    watch: {
    },
});
